import { useCifraClient } from '@/api/cifra-client';

const { cifraClient } = useCifraClient();

export default {
  calificacionesAlumno(alumnoId, fecha, parametros) {
    const params = { alumno_id: alumnoId, fecha, ...parametros };
    return cifraClient.get('/api_publica/v1/items_diarios/calificaciones_alumno', {
      params,
    });
  },
  infoGeneralAlumno(alumnoId, parametros = {}) {
    const params = { alumno_id: alumnoId, ...parametros };
    return cifraClient.get('/api_publica/v1/items_diarios/info_general_alumno', {
      params,
    });
  },
  estadisticasAlumno(
    alumnoId,
    asignaturaId,
    evaluacionId = null,
    fecha = null,
    vistaFamilia = false,
    fechaDesde = null,
    fechaHasta = null,
  ) {
    const params = {
      alumno_id: alumnoId,
      asignatura_id: asignaturaId,
      evaluacion_id: evaluacionId,
      fecha,
      vista_familia: vistaFamilia,
      fecha_desde: fechaDesde,
      fecha_hasta: fechaHasta,
    };
    return cifraClient.get('/api_publica/v1/items_diarios/estadisticas', {
      params,
    });
  }
};
